import { render, staticRenderFns } from "./SpecialOfferTrialAdsPage.vue?vue&type=template&id=06583c50&scoped=true"
import script from "./SpecialOfferTrialAdsPage.vue?vue&type=script&lang=ts"
export * from "./SpecialOfferTrialAdsPage.vue?vue&type=script&lang=ts"
import style0 from "./SpecialOfferTrialAdsPage.vue?vue&type=style&index=0&id=06583c50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06583c50",
  null
  
)

export default component.exports